<template>
  <div id="EditSchoolGatherPlace" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回學校集合地點列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
        <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
         <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>學校集合地點:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData[0].schoolGatherPlace"

                  placeholder="請輸入學校集合地點"
                />
              </div>
            </td>
          </tr>



        </tbody>
      </table>
    </div>

        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="EditSchoolGatherPlace()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>

  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "EditSchoolGatherPlace",
  props: ["pid"],

  data() {
    return {
      RowId:"",
      AttachContent:[],
      mode: false,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      total: 0,
      isIE: false,
      getTeacherData: null,
       inputData: [{
        pid:0,
        schoolGatherPlace:null,
           }],
      currentPage: 1,

      pageSize: 10,

    };
  },
  computed: {
  user () {
   return this.$store.getters.getUser
   },

  },
  methods: {

    hideModal(name) {
      this.$refs[name].hide();

    },

    checkInput() {
   this.inputFlag = false;
      if (tools.empty(this.inputData[0].schoolGatherPlace)) {
        alert("請輸入學校集合地點");

        this.inputFlag = true;
        return;
      }



    },

    EditSchoolGatherPlace() {
      this.checkInput();
       let vm = this;


      if (this.inputFlag != true) {
        this.$http
          .put("./WebApi/HighSchoolEnrolling/EditSchoolGatherPlace/", this.inputData[0])
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "更新學校集合地點成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,更新學校集合地點失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },

    close() {
      this.$emit("hideModal");
    },

  },
  created() {
    console.log("======created EditSchoolGatherPlaceView =====");

    let vm = this;

    vm.inputData[0].pid = this.$props.pid;
    this.$http
      .get("../WebApi/HighSchoolEnrolling/GetSchoolGatherPlaceDetail/".concat(vm.inputData[0].pid))
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data;

        }
      })
      .catch(function (error) {
        alert("網路連線失敗" + error);

      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
